/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
/* jsx-a11y/label-has-associated-control */
import React from 'react';
import advSearchState from 'Stores/advSearch';
import { observer } from 'mobx-react';
// import { makeApi, URLS } from 'Utils/apiUtil';
import { advSearchFilterPopupState } from 'Stores/advSearchFIlterPopup';
import { userDetail } from 'Stores/userDetail';
import CheckBox from 'Components/common/CheckBox';

const Options = observer(props => {
  // const suggestionKey = 'options';
  const { filterInPage = false } = props;
  let checkBoxFilters;
  if (filterInPage) checkBoxFilters = advSearchState.checkBoxFilters;
  else checkBoxFilters = advSearchFilterPopupState.checkBoxFilters;

  const onCheckBoxClick = val => {
    if (filterInPage) {
      console.log('true');
      advSearchState.setCheckBoxFilters(val);
    } else {
      console.log('fal');
      advSearchFilterPopupState.setCheckBoxFilters(val);
    }
  };

  return (
    <div className="input-section options-section check-box-wrap">
      <div className="options-header">Options</div>
      <div
        className={`title-checkbox${
          checkBoxFilters.dontDisplayOwnedContacts ? ' selected' : ''
        }`}
        onClick={() => onCheckBoxClick('dontDisplayOwnedContacts')}
      >
        <div className="check-box">
          <CheckBox
            dymamicClass={
              checkBoxFilters.dontDisplayOwnedContacts ? 'selected' : ''
            }
          />
        </div>
        <span className="check-box-label">Exclude contacts I own</span>
      </div>
      <div
        className={`title-checkbox${
          checkBoxFilters.dontDisplayTeamContacts ? ' selected' : ''
        }`}
        onClick={() => onCheckBoxClick('dontDisplayTeamContacts')}
      >
        <div className="check-box">
          <CheckBox
            dymamicClass={
              checkBoxFilters.dontDisplayTeamContacts ? 'selected' : ''
            }
          />
        </div>
        <span className="check-box-label">Exclude contacts my team owns</span>
      </div>
      {/* <div
        className={`title-checkbox${
          checkBoxFilters.dontDisplayDeadContacts ? ' selected' : ''
        }`}
        onClick={() => onCheckBoxClick('dontDisplayDeadContacts')}
      >
        <div className="check-box">
          <CheckBox
            dymamicClass={
              checkBoxFilters.dontDisplayDeadContacts ? 'selected' : ''
            }
          />
        </div>
        <span className="check-box-label">Exclude inactive contacts</span>
      </div> */}
    </div>
  );
});

export { Options };
export default Options;
